/* eslint-disable jsx-a11y/anchor-has-content,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import { sendRequest as sendTaskRemoveRequest } from 'mt-react-common/modules/tasks/common/reducers/taskRemoveForm';
import { sendRequest as sendTaskActivateRequest } from 'mt-react-common/modules/tasks/common/reducers/taskActivateForm';
import { sendRequest as sendTaskStopRequest } from 'mt-react-common/modules/tasks/common/reducers/taskStopForm';

import TaskPanelHeader from '../../_common/TaskPanelHeader';
import TaskPanelBodyAsOwner from '../../_common/TaskPanelBodyAsOwner';

const tasksCollectionRName = 'tasksModule.collections.tasksCollection';

// eslint-disable-next-line react/prefer-stateless-function
class TaskOwnerItem extends Component {
  render() {
    return (
      <React.Fragment>
        <article
          className={`panel task task_detailed panel-default ${
            this.props.task.upListMarkNow !== null ? 'panel-primary' : ''
          }`}
        >
          <div
            aria-labelledby="myModalLabel"
            className="modal fade"
            role="dialog"
            tabIndex="-1"
            id={`modalDelete-${this.props.task.id}`}
          >
            <div className="modal-dialog modal-gray modal-sm">
              <div className="modal-content">
                <div className="modal-header text-center">
                  <a
                    aria-label="Close"
                    className="close close-black"
                    data-dismiss="modal"
                    href=""
                  />
                  <i className="fa fa-exclamation-triangle modal-icon" />
                  <h4 className="modal-title">
                    <strong>{t('Подтверждение')}</strong>
                  </h4>
                </div>
                <div className="modal-body text-center">
                  {t('Вы действительно хотите удалить задачу?')}
                </div>
                <div className="modal-footer">
                  <a
                    className="btn btn-muted"
                    data-dismiss="modal"
                    href=""
                    type="button"
                  >
                    Отмена
                  </a>
                  <a
                    className="btn btn-danger"
                    data-dismiss="modal"
                    href=""
                    type="button"
                    onClick={() => this.props.removeTask()}
                  >
                    {t('Удалить')}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <TaskPanelHeader task={this.props.task} />
          <TaskPanelBodyAsOwner task={this.props.task} />
          <div className="panel-footer panel-inner-border-top">
            <div className="btn-toolbar">
              <div className="btn-group btn-group-sm pull-left">
                <NavLink
                  to={`/my-tasks/copy/${this.props.task.id}`}
                  className="btn btn-muted"
                  type="button"
                >
                  <i className="fa fa-files-o" /> {t('Копировать')}
                </NavLink>
                {![4, 5].includes(this.props.task.status) ? (
                  <React.Fragment>
                    <NavLink
                      to={`/my-tasks/edit/${this.props.task.id}`}
                      className="btn btn-muted"
                      type="button"
                    >
                      <i className="fa fa-pencil" /> {t('Редактировать')}
                    </NavLink>
                    <a
                      className="btn btn-muted"
                      data-toggle="modal"
                      type="button"
                      href={`#modalDelete-${this.props.task.id}`}
                    >
                      <i className="fa fa-trash" /> {t('Удалить')}
                    </a>
                  </React.Fragment>
                ) : null}
              </div>
              {[1].includes(this.props.task.status) ? (
                <button
                  className="btn btn-danger btn-sm"
                  type="button"
                  onClick={() => this.props.stopTask()}
                >
                  {t('Остановить')}
                </button>
              ) : null}
              {[2].includes(this.props.task.status) ? (
                <button
                  className="btn btn-success btn-sm"
                  type="button"
                  onClick={() => this.props.startTask()}
                >
                  {t('Активировать')}
                </button>
              ) : null}
            </div>
          </div>
        </article>
      </React.Fragment>
    );
  }
}

TaskOwnerItem.propTypes = {
  startTask: PropTypes.func.isRequired,
  stopTask: PropTypes.func.isRequired,
  removeTask: PropTypes.func.isRequired,
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    taskDomain: PropTypes.string.isRequired,
    ownerId: PropTypes.number.isRequired,
    ownerUserName: PropTypes.string.isRequired,
    ownerAvatarPath: PropTypes.string.isRequired,
    costExecution: PropTypes.string.isRequired,
    totalCostExecution: PropTypes.string.isRequired,
    maxExecutions: PropTypes.number.isRequired,
    taskTypeDesc: PropTypes.string.isRequired,
    checkTypeDesc: PropTypes.string.isRequired,
    executorExecutionIntervalDesc: PropTypes.string.isRequired,
    timePerformDesc: PropTypes.string.isRequired,
    hasGeoTarget: PropTypes.bool.isRequired,
    hasTimeTarget: PropTypes.bool.isRequired,
    taskCommentsStat: PropTypes.shape({
      dislikes: PropTypes.number.isRequired,
      likes: PropTypes.number.isRequired,
      neutral: PropTypes.number.isRequired
    }).isRequired,
    tasksExecsStat: PropTypes.shape({}).isRequired,
    statFinishedExecs: PropTypes.number.isRequired,
    upListFastenNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    upListMarkNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    timeTarget: PropTypes.arrayOf(PropTypes.shape).isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch, props) => ({
  removeTask: () =>
    dispatch(
      sendTaskRemoveRequest('tasksModule.forms.taskRemoveForm', props.task.id)
    ),
  stopTask: () =>
    dispatch(
      sendTaskStopRequest('tasksModule.forms.taskStopForm', props.task.id)
    ),
  startTask: () =>
    dispatch(
      sendTaskActivateRequest(
        'tasksModule.forms.taskActivateForm',
        props.task.id
      )
    )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TaskOwnerItem)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksListAsOwner/TaskItemAsOwner/TaskOwnerItem.js